import { BaseState } from '@/store/base-state';
import { Contacts, SendAppeal } from '../types';

export default class ContactsState extends BaseState {
  cards: Contacts.Card[] = [];
  card_items: Contacts.CardItems[] = [];
  uploaded_files: File[] = [];

  appeal_payload: SendAppeal = {
    title: '',
    description: '',
    mail_to: '',
    files: this.uploaded_files,
  }
}
